import React from 'react';
import { useTranslation } from 'react-i18next';
import InfoCircleOutlined from '@ant-design/icons/InfoCircleOutlined';
import { Tooltip } from 'antd';
import styled from '@emotion/styled';

export const DocmanConsentTooltipContent = () => {
  const { t } = useTranslation('common');

  return (
    <>
      <p>
        {t(
          'Indicates whether the patient has consented to automatically sharing case documentation and reports with their GP via Docman, a secure electronic document management system.'
        )}
      </p>
      <ul style={{ margin: 0, padding: 0 }}>
        <li>
          <strong>{t('Yes')}:</strong> {t('The patient has consented to automatic sharing.')}
        </li>
        <li>
          <strong>{t('Withheld consent')}:</strong> {t(' The patient has not consented to automatic sharing.')}
        </li>
        <li>
          <strong>{t('Unavailable')}:</strong>{' '}
          {t(
            'The patient has not yet responded to the consent question, or automatic sharing is unavailable due to missing GP details or their GP practice not accepting documents via Docman.'
          )}
        </li>
      </ul>
    </>
  );
};

const TooltipWrapper = styled.span`
  margin-left: 0.5rem;
  font-size: 16px;
`;

type ConsentStatusProps = {
  docmanActive?: boolean;
  consentGiven?: boolean;
} & React.HTMLAttributes<HTMLSpanElement>;

const DocmanConsentStatusWithTooltip: React.FC<ConsentStatusProps> = ({ docmanActive, consentGiven, ...props }) => {
  const { t } = useTranslation('common');

  const getDocmanConsentText = () => {
    if (!docmanActive) return t('Unavailable');
    return consentGiven ? t('Yes') : t('Withheld consent');
  };

  return (
    <span {...props}>
      {getDocmanConsentText()}
      <Tooltip title={<DocmanConsentTooltipContent />} trigger={['hover', 'focus']}>
        <TooltipWrapper>
          <InfoCircleOutlined />
        </TooltipWrapper>
      </Tooltip>
    </span>
  );
};

export default DocmanConsentStatusWithTooltip;
